export const inspectTable = [
  {
    content: "산업재해 발생보고 및 산업재해발생기록 (법 제57조)",
    isChecked: "",
  },
  {
    content: "산업안전보건법의 법령요지 게시 및 비치 (법 제34조)",
    isChecked: "",
  },
  {
    content: "유해하거나 위험한 시설 및 장소에 금지·경고·지시표지 등 부착 (법 제37조)",
    isChecked: "",
  },
];
